import "./footer.css";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>Copyright {new Date().getFullYear()} © NemeaGov</p>
      </div>
    </footer>
  );
};

export default Footer;
